export default "__VITE_ASSET__Hj62_jUE__"